import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { LeadActivityService } from 'src/app/private/services/lead-activity.service';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-lead-profile-followup',
  templateUrl: './lead-profile-followup.component.html',
  styleUrls: ['./lead-profile-followup.component.scss'],
})
export class LeadProfileFollowupComponent implements OnInit {
  @Input() leadId!: number | string;
  @Output() saved = new EventEmitter<void>();

  followUpAction = '';
  followUpMode = '';
  remark = '';
  followUpDate = '';
  setReminder = false;
  reminderDate = '';
  btnLoading = false;
  isCron = 'False';
  todayDate = moment().format('YYYY-MM-DD');

  followUpModes = ['Call', 'Email', 'Meeting', 'SMS', 'WhatsApp'];

  constructor(
    private api: LeadService,
    private leadActivity: LeadActivityService,
    private toast: ToastrService,
    private localStorage: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.isCron = this.localStorage.getCron() || 'False';
    this.followUpDate = this.todayDate;
  }

  submit(): void {
    if (!this.followUpAction?.trim()) {
      this.toast.error('Please enter follow up action');
      return;
    }
    if (!this.followUpMode) {
      this.toast.error('Please select follow-up mode');
      return;
    }
    if (!this.followUpDate) {
      this.toast.error('Please select follow up date');
      return;
    }
    if (this.setReminder && this.isCron === 'True' && !this.reminderDate) {
      this.toast.error('Please add reminder date');
      return;
    }

    const remarksText = [
      this.remark?.trim(),
      `[Mode: ${this.followUpMode}]`,
    ]
      .filter(Boolean)
      .join(' ');

    const payload = {
      client_id: this.localStorage.getClientId(),
      lead_id: this.leadId,
      center_id: this.localStorage.getCenterId(),
      date: this.followUpDate,
      time: moment().format('HH:mm'),
      remarks: remarksText || this.followUpAction,
      notification_date: this.setReminder && this.reminderDate ? this.reminderDate : null,
      user_id: parseInt(this.localStorage.getUserId(), 10),
      next_action: this.followUpAction,
      updated_by: { email: this.localStorage.getEmail() },
    };

    this.btnLoading = true;
    this.api.addLeadFollowUp(payload).subscribe({
      next: (res: any) => {
        const historyId = res?.id;
        const desc = `Follow-up (${this.followUpMode}): ${this.followUpAction}`;
        const log$ = historyId
          ? this.leadActivity.recordFollowUp(this.leadId, historyId, desc)
          : this.leadActivity.record(this.leadId, 'lead_followup_activity', desc, {
              related_table: 'leadhistoryrecord',
            });
        const finish = () => {
          this.toast.success('Follow-up added successfully');
          this.resetForm();
          this.btnLoading = false;
          this.saved.emit();
        };
        log$.subscribe({ next: finish, error: finish });
      },
      error: (err) => {
        this.toast.error(err?.error?.message || 'Failed to add follow-up');
        this.btnLoading = false;
      },
    });
  }

  private resetForm(): void {
    this.followUpAction = '';
    this.followUpMode = '';
    this.remark = '';
    this.followUpDate = this.todayDate;
    this.setReminder = false;
    this.reminderDate = '';
  }
}
